module.exports = __webpack_public_path__ + "img/logo-white.45b3837b.png";